import Navigation from "../components/Navigation";
import Therapists from "../components/Therapists";
import LanguageSwitcher from "../components/LanguageSwitcher";
import CookieNotice from "../components/CookieNotice";

const TherapistsPage = () => {
  return (
    <Navigation>
      <LanguageSwitcher />
      <CookieNotice />

      <main className="min-h-screen bg-white">
        <Therapists />
      </main>
    </Navigation>
  );
};

export default TherapistsPage;
